// const globalSearch = (collection, key = "") => {
//   if (!key || typeof key !== "string") return [];
//   key = key.toUpperCase(); // Normalize search key
//   return collection.filter((obj) => {
//     if (!obj) {
//       return false;
//     }

//     if (typeof obj === "object") {
//       return Object.values(obj).some((value) => {
//         if (typeof value === "object") {
//           return globalSearch([value], key).length > 0; // Recursively search nested objects
//         }
//         return String(value).toUpperCase().includes(key);
//       });
//     }

//     return String(obj).toUpperCase().includes(key);
//   });
// };

// export default globalSearch;

const globalSearch = (collection, key = "") => {
  if (!key || typeof key !== "string") return [];

  const normalize = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  const wildcardKey = String(key || "").replace(/%/g, " ").trim();
  const normalizedKey = normalize(wildcardKey);
  const tokens = wildcardKey
    .split(/\s+/)
    .map(normalize)
    .filter(Boolean);

  const flattenObject = (obj) => {
    let result = [];

    for (const value of Object.values(obj)) {
      if (value && typeof value === "object") {
        result = result?.concat(flattenObject(value));
      } else {
        result?.push(String(value));
      }
    }

    return result;
  };

  return collection.filter((obj) => {
    if (!obj || typeof obj !== "object") return false;

    const flattenedValues = flattenObject(obj)
      .map((value) => normalize(String(value || "")))
      .filter(Boolean);
    const allValues = flattenedValues.join("");

    if (normalizedKey && allValues.includes(normalizedKey)) {
      return true;
    }

    if (!tokens.length) return false;

    return tokens.every((token) =>
      flattenedValues.some((value) => value.includes(token)) ||
      allValues.includes(token),
    );
  });
};

export default globalSearch;
